import { useQueryClient } from '@tanstack/react-query';
import { api } from '../../lib/api';
import { signOut } from '../../lib/auth';

/**
 * Signing out, in the order 04 § 11.5 gives: the server's session cache first,
 * then OtterAuth, then everything this tab holds.
 *
 * The cache has to be cleared as well as the store — TanStack keeps the last
 * answer for every admin query, and those are exactly the rows the next person
 * at this screen should not see.
 */
export function useSignOut(): () => Promise<void> {
  const queryClient = useQueryClient();

  return async () => {
    await signOut(() => api.POST('/auth/logout'));
    queryClient.clear();
    window.location.replace('/login');
  };
}
